import {makeStyles} from '../theme'

export const useClasses = makeStyles(
  {
    root: {
      width: '100%',
      height: '100%',
    },
  },
  {name: 'YandexMap'},
)
